export default function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-select/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
// module id = null
// module chunks = 